import { makeStyles } from '@material-ui/core/styles'
// import { spacing } from 'react-select/src/theme'
import { BREAKPOINTS, COLORS, FONTS, WIDTH_DIMENSIONS } from '../constants'

export const styles = makeStyles(theme => ({
  seoHeading: {
    fontSize: '16px !important',
    fontFamily: 'Graphik Light !important',
    letterSpacing: '0.00938em !important',
    lineHeight: '1.75 !important',
    marginBottom: '0px !important',
    marginTop: '10px !important',
    fontWeight: 400,
  },
  headingWrapper: {
    width: '100%',
    background: COLORS.whiteStain,
    padding: '10px 0px',
    marginBottom: 40,
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      padding: '40px 20px',
    },
  },
  headingContainer: {
    width: '90%',
    display: 'flex',
    maxWidth: WIDTH_DIMENSIONS.max,
    margin: 'auto',
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      width: '100%',
      flexDirection: 'column',
    },
  },
  headingTextContainer: {
    width: 'calc(50% - 10px)',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: 10,
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      width: '100%',
      paddingRight: 0,
    },
    [`& nav.MuiBreadcrumbs-root`]: {
      marginBottom: 15,
    },
    [`& li.MuiBreadcrumbs-li a`]: {
      fontSize: '14px !important',
      fontWeight: 300,
      color: COLORS.black,
      letterSpacing: '0.38px',
      lineHeight: '15px',
      cursor: 'pointer',
      fontFamily: 'Graphik Light',
    },
    [`& li.MuiBreadcrumbs-separator`]: {
      fontSize: '14px !important',
      fontWeight: 300,
      letterSpacing: '0.38px',
      lineHeight: '15px',
      fontFamily: 'Graphik Light',
      color: COLORS.black,
      marginTop: 5,
    },
    [`& li.MuiBreadcrumbs-li p`]: {
      height: 27.43,
      fontSize: '14px !important',
      fontWeight: 300,
      letterSpacing: '0.38px',
      lineHeight: '31px',
      fontFamily: 'Graphik Light',
      color: COLORS.black,
    },
  },
  actionButtonsContainer: {
    width: 'calc(50% - 10px)',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 10,
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      width: '100%',
      paddingLeft: 0,
    },
  },
  headingLogoContainer: {
    display: 'flex',
  },
  headingLogoImage: {
    borderRadius: 999,
    width: 100,
    height: 100,
    backgroundColor: '#232323',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      width: 80,
      height: 80,
    },
  },
  headingLogoText: {
    paddingLeft: 21,
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      overflowX: 'scroll',
    },
  },
  categoryName: {
    fontSize: '5rem',
    fontFamily: 'Schnyder M Light',
    fontWeight: 300,
    textTransform: 'lowercase',
    letterSpacing: 0,
    lineHeight: '65px',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      fontSize: '2.8125rem',
      lineHeight: '50px',
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      fontSize: 45,
      lineHeight: '50px',
    },
  },
  categoryDescription: {
    maxWidth: 585,
    letterSpacing: 0,
    fontSize: '16px',
    fontFamily: 'Graphik Light',
    lineHeight: ' 23px',
    marginBottom: 0,
    marginTop: 10,
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      marginBottom: 20,
      marginLeft: 0,
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      fontSize: '14px',
      marginTop: 5,
      letterSpacing: 0.38,
    },
  },
  visitButtonContainer: {
    maxWidth: 343,
    width: '100%',
    alignSelf: 'flex-end',
    flexGrow: 1,
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      alignSelf: 'center',
    },
  },
  visitButton: {
    textDecoration: 'none',
    padding: '20px 0',
    background: COLORS.white,
    textAlign: 'center',
    color: COLORS.black,
    letterSpacing: '1.2px',
    lineHeight: '14px',
    display: 'block',
  },
  filtersContainer: {
    display: 'flex',
    // when add refine change the 2 lines below
    // justifyContent: 'space-between',
    justifyContent: 'flex-end',
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      [`& > div:last-child`]: {
        marginLeft: 20,
      },
    },
  },
  filterButton: {
    width: 'calc(50% - 10px)',
  },
  filterButton2: {
    width: 'calc(50% - 10px)',
    [`& div.select-list`]: {
      marginLeft: 20,
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      [`& div.select-list`]: {
        marginLeft: 12,
      },
    },
  },
  productsContainer: {
    fontFamily: FONTS.Graphik.GraphikLight,
    width: '100%',
    margin: '0 auto',
    overflow: 'hidden',
    maxWidth: WIDTH_DIMENSIONS.max,
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      width: '90%',
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      width: '90%',
    },
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 30,
  },
  countingFilterContainer: {
    display: 'flex',
    marginBottom: 20,
    paddingRight: 10,
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      display: 'none',
    },
  },
  countingFilterContainer2: {
    display: 'flex',
    marginBottom: 32,
    paddingRight: 10,
  },
  itemsCount: {
    color: COLORS.ashGrey,
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '1rem',
    letterSpacing: '1px',
    lineHeight: '18p',
    textTransform: 'uppercase',
  },
  readMore: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  joinButton: {
    maxWidth: 233,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: COLORS.white,
    padding: 20,
    cursor: 'pointer',
    textAlign: 'center',
    textDecoration: 'none',
    color: 'inherit',
    border: '2px black solid',
  },
  joinCard: {
    backgroundColor: COLORS.whiteStain,
    height: 454,
    paddingTop: 50,
    paddingLeft: 50,
    paddingRight: 50,
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      height: 307,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      height: 307,
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  cardText: {
    letterSpacing: 0,
    textAlign: 'center',
    marginTop: 50,
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      fontSize: 36,
      marginTop: 10,
    },
  },
}))
